import { getStoredUser } from '../lib/auth';

/**
 * Check if current user has a specific permission
 */
export function usePermissions() {
  const user = getStoredUser();
  const permissions = user?.permissions || [];
  const roles = user?.roles || [user?.role || ''];

  const hasPermission = (resource: string, action: string): boolean => {
    return permissions.includes(`${resource}:${action}`) || permissions.includes('platform:manage');
  };

  const hasRole = (...checkRoles: string[]): boolean => {
    return checkRoles.some(r => roles.includes(r));
  };

  const isAdmin = hasRole('super_admin', 'school_admin', 'transport_coordinator', 'fleet_manager') || user?.role === 'admin';
  const isSuperAdmin = hasRole('super_admin');
  const isDriver = hasRole('driver') || user?.role === 'driver';
  const isParent = hasRole('parent') || user?.role === 'parent';
  const isStaff = hasRole('staff', 'security_guard');

  return {
    hasPermission,
    hasRole,
    isAdmin,
    isSuperAdmin,
    isDriver,
    isParent,
    isStaff,
    permissions,
    roles,
  };
}
